import { connect } from 'react-redux'
import { selectLanguage } from 'store/locales'
import ArticleSix from '../components/ArticleSix'

const mapStateToProps = ({ strings }) => {
  return {
    strings,
  }
}

const mapDispatchToProps = {
  selectLanguage,
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleSix)
